import {useParams} from 'react-router-dom';
import {
    FacebookShareButton,
    FacebookMessengerShareButton,
    TwitterShareButton,
    RedditShareButton,
    WhatsappShareButton, TelegramShareButton,
} from 'react-share';
import apiClient from '../../api/apiClient';
//== Icons
import FacebookSvg from '../../assets/icons/shareFacebook.svg';
import MessengerSvg from '../../assets/icons/shareMessenger.svg';
import RedditSvg from '../../assets/icons/shareReddit.svg';
import TelegramSvg from '../../assets/icons/shareTelegram.svg';
import TwitterSvg from '../../assets/icons/shareTwitter.svg';
import WhatsappSvg from '../../assets/icons/shareWhatsapp.svg';
//== Styles
import Classes from './ShareSocial.module.scss';

const ShareSocial = ({resourceData, width, className = ''}: any) => {
    const params: any = useParams();
    const {filePath, title, tags, _id} = resourceData;

    //== when click share button click url api
    const shareLinkApi = async (type: any) => {
        if (navigator?.share) {
            await navigator?.share({
                url: `${process.env.REACT_APP_BASE_URL}/gif/${encodeURIComponent(params?.slug)}/${filePath?.replace('resources/', '')}`,
                title: title
            }).then(() => {
                apiClient.get(`${process.env.REACT_APP_GIFBUZ_API}/resources/update-social-share-count/${_id}/${type}/web`);
            });
        } else {
            apiClient.get(`${process.env.REACT_APP_GIFBUZ_API}/resources/update-social-share-count/${_id}/${type}/web`);
        }
    };

    return (
        <div className={Classes.shareSocialWrap}>
            {width >= 992 && (
                <h5>Share GIF on Social Media</h5>
            )}

            <div className={`${Classes.socialMediasBtnWrap} d-flex align-items-center flex-wrap ${className}`}>
                <FacebookShareButton
                    url={`${process.env.REACT_APP_BASE_URL}/gif/${encodeURIComponent(params?.slug)}/${filePath?.replace('resources/', '')}`}
                    quote={title}
                    hashtag={tags}
                    onClick={() => shareLinkApi('facebook')}
                >
                    <img src={FacebookSvg} alt="Facebook" className={'img-fluid'}/>
                </FacebookShareButton>

                <FacebookMessengerShareButton
                    appId={`${process.env.REACT_APP_FACEBOOK_APP_ID}`}
                    url={`${process.env.REACT_APP_BASE_URL}/gif/${encodeURIComponent(params?.slug)}/${filePath?.replace('resources/', '')}`}
                    onClick={() => shareLinkApi('messenger')}
                >
                    <img src={MessengerSvg} alt="Messenger" className={'img-fluid'}/>
                </FacebookMessengerShareButton>

                <TwitterShareButton
                    url={`${process.env.REACT_APP_BASE_URL}/gif/${encodeURIComponent(params?.slug)}/${filePath?.replace('resources/', '')}`}
                    title={title}
                    hashtags={[tags]}
                    onClick={() => shareLinkApi('twitter')}
                >
                    <img src={TwitterSvg} alt="Twitter" className={'img-fluid'}/>
                </TwitterShareButton>

                <WhatsappShareButton
                    url={`${process.env.REACT_APP_BASE_URL}/gif/${encodeURIComponent(params?.slug)}/${filePath?.replace('resources/', '')}`}
                    title={title}
                    onClick={() => shareLinkApi('whatsapp')}
                >
                    <img src={WhatsappSvg} alt="Whatsapp" className={'img-fluid'}/>
                </WhatsappShareButton>

                <TelegramShareButton
                    url={`${process.env.REACT_APP_BASE_URL}/gif/${encodeURIComponent(params?.slug)}/${filePath?.replace('resources/', '')}`}
                    title={title}
                    onClick={() => shareLinkApi('telegram')}
                >
                    <img src={TelegramSvg} alt="Telegram" className={'img-fluid'}/>
                </TelegramShareButton>

                <RedditShareButton
                    url={`${process.env.REACT_APP_BASE_URL}/gif/${encodeURIComponent(params?.slug)}/${filePath?.replace('resources/', '')}`}
                    title={title}
                    onClick={() => shareLinkApi('redit')}
                >
                    <img src={RedditSvg} alt="Reddit" className={'img-fluid'}/>
                </RedditShareButton>
            </div>
        </div>
    );
};

export default ShareSocial;